import { READ_ALERTS_API } from "../helpers/api-path";
import httpClient from "./http.interceptor";

const readAlertsAPI = async (formData) => {
    const URL = READ_ALERTS_API+"?environment="+process.env.REACT_APP_ENVIRONMENT;
    return await httpClient.post(URL, { ...formData })
}

export {
    readAlertsAPI
}